// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';

// Portfolio Content
import projectReducer from './slices/projectSlice';
import skillReducer from './slices/skillSlice';
import experienceReducer from './slices/experienceSlice';
import educationReducer from './slices/educationSlice';
import serviceReducer from './slices/serviceSlice';
import testimonialReducer from './slices/testimonialSlice';
import socialLinkReducer from './slices/socialLinkSlice';

// Blog
import blogReducer from './slices/blogSlice';

// Settings
import settingsReducer from './slices/settingsSlice';

// Engagement
import inquiryReducer from './slices/inquirySlice';

// Analytics
import chatbotReducer from './slices/chatbotSlice';
import trackingReducer from './slices/trackingSlice';

// FAQ
import faqReducer from './slices/faqSlice';

// UI
import uiReducer from './slices/uiSlice';

export const store = configureStore({
    reducer: {
        projects: projectReducer,
        skills: skillReducer,
        experiences: experienceReducer,
        educations: educationReducer,
        services: serviceReducer,
        testimonials: testimonialReducer,
        socialLinks: socialLinkReducer,
        blogs: blogReducer,
        settings: settingsReducer,
        inquiries: inquiryReducer,
        chatbot: chatbotReducer,
        tracking: trackingReducer,
        faqs: faqReducer,
        ui: uiReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
